import { useState, useEffect } from 'react';
import UserService from '../services/user';

export const useDirectReportee = ({ attendees, userId, isOneOnOne = false }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [directReporteeId, setDirectReporteeId] = useState(0);
  const [managerId, setManagerId] = useState(0);

  const handleFetchData = async () => {
    const idProp = isOneOnOne ? 'user_id' : 'id';
    if (isOneOnOne) {
      const firstAttendee = attendees.find((a) => +a[idProp] === +userId);
      const secondAttendee = attendees.find((a) => +a[idProp] !== +userId);
      const isSecondAttendeeDirectReport = await UserService.isDirectReportee(secondAttendee?.[idProp]);
      setDirectReporteeId(isSecondAttendeeDirectReport ? secondAttendee?.[idProp] : firstAttendee?.[idProp]);
      setManagerId(isSecondAttendeeDirectReport ? firstAttendee?.[idProp] : secondAttendee?.[idProp]);
    } else {
      const organizer = attendees.find((a) => a.isOrganizer === true);
      const attendee = attendees.find((a) => a.isOrganizer === false);
      setDirectReporteeId(attendee?.[idProp]);
      setManagerId(organizer?.[idProp]);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    if (attendees?.length > 0 && userId) handleFetchData();
  }, [attendees, userId]);

  return { loadingDirectReportee: isLoading, directReporteeId, managerId };
};
